import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../helpers/utils";
import { tabRightChilds } from "../TabsSidebar";
import { useSelector, useDispatch } from "react-redux";
import { changeTabRightState, setTabRightMode } from "../../redux/actions/sharedActions";
import Notification from "rc-notification";
import { useAxios } from "../../helpers/apiHelper";

let notification = null;
Notification.newInstance(
   {
      closable: true,
      duration: 3,
      style: {
         top: 50,
         right: 20,
         color: "#000",
      },
   },
   (n) => (notification = n)
);
export default function Footer(props) {
   const axios = useAxios();
   const { showUnitNote, isOddLot, isAutoScroll } = props;
   const dispatch = useDispatch();
   const userToken = useSelector((state) => state.gUser.token ?? "");
   const hideTabRight = useSelector((state) => state.gShared.hideTabRight);
   const currentTabRight = useSelector((state) => state.gShared.currentTabRight);
   const tabRightMode = useSelector((state) => state.gShared.tabRightMode);
   const language = useSelector((state) => state.gShared.language);

   const serverTime = useSelector((state) => state.gShared.serverTime);
   const serverDate = serverTime > 0 ? new Date(serverTime) : new Date();

   const [newList, setNewList] = useState([]);

   const { t } = useTranslation();
   //
   const [currentActive, setCurrentActive] = useState("");
   const handleClick = (tabName) => {
      if (userToken !== "") {
         let _newHidden = hideTabRight;
         let _newTab = currentTabRight;
         if (_newHidden) {
            // An => Hien
            _newHidden = false;
            if (tabRightMode === "FLOAT") {
               setCurrentActive("active");
            }
            setTabRightMode(dispatch, "INSET");
         } else {
            setTabRightMode(dispatch, "FLOAT");

            // Da hien
            if (_newTab === tabName) {
               // Hien => An
               _newHidden = true;
               setCurrentActive("");
            }
         }
         _newTab = tabName;
         changeTabRightState(dispatch, _newHidden, _newTab);
      } else {
         notification.notice({
            style: {
               color: "red",
            },
            content: "Cần đăng nhập",
         });
      }
   };

   useEffect(() => {
      getListNew();
   }, []);

   const getListNew = async () => {
      try {
         const response = await axios.get(`new-home?language=${language}`);

         if (response && response.status === 200) {
            setNewList(response?.data);
         }
      } catch (error) {}
   };

   const [visibleIndex, setVisibleIndex] = useState(0);

   useEffect(() => {
      const intervalId = setInterval(() => {
         setVisibleIndex((prevIndex) => (prevIndex + 1) % newList.filter((e) => e.type === 1).length);
      }, 3000);

      return () => clearInterval(intervalId);
   }, [newList]);

   return (
      <div className="footer-icon-order">
         <div className="footer d-flex">
            <div className="txtc">
               ĐƠN VỊ GIÁ: 1,000 ĐỒNG <br />
               ĐƠN VỊ KHỐI LƯỢNG: 10 CỔ PHIẾU <br />
               <span id="txtWarn" style={{ color: "#f6ab04", display: "none" }}>
                  Qúy khách vui lòng sử dụng trình duyệt Chrome phiên bản mới nhất để trải nghiệm tốt hơn.
               </span>
            </div>
            {isAutoScroll && (
               <div className="time-footer-scroll">
                  <div className="timefoot__now">{serverDate.toLocaleTimeString("en-GB")}</div>
                  <div className="timefoot__date">{serverDate.toLocaleDateString("en-GB")}</div>
               </div>
            )}
            <div className="copyright">
               <a>© Công ty cổ phần Chứng khoán Tân Việt (TVSI) </a>
               <br />
               <a>Tầng 17, Tòa nhà VCCI Tower, Số 9 Đào Duy Anh, P.Kim Liên, TP.Hà Nội. * Hotline: 1900 1885* Email: </a>
               <a className="class-foot" href="mailto:contact@tvsi.com.vn">
                  contact@tvsi.com.vn
               </a>
               <br />
               <a className="class-foot" href="https://navisoft.com.vn/">
                  Phát triển bởi Navisoft
               </a>
            </div>
         </div>

         <div className="main-news d-flex">
            <div className="latest-news">
               <span className="title-footer">
                  <i className="fas fa-bell"></i>
                  Thị trường cổ phiếu
               </span>
               <div className="marquee test test28">
                  {newList
                     .filter((e) => e.type === 0)
                     .map((e, idx) => (
                        <a key={idx} className="content-foot" target="_blank" rel="noopener noreferrer" href={e.urlLink} style={{ display: visibleIndex === idx ? "block" : "none" }}>
                           {e.title}
                        </a>
                     ))}
               </div>
            </div>
            <div className="latest-news">
               <span className="title-footer">
                  <i className="fas fa-bell"> </i>
                  Thông báo từ TVSI
               </span>
               <div className="marquee test test29">
                  {newList
                     .filter((e) => e.type === 1)
                     .map((e, idx) => (
                        <a key={idx} className="content-foot" target="_blank" rel="noopener noreferrer" href={e.urlLink} style={{ display: visibleIndex === idx ? "block" : "none" }}>
                           {e.title}
                        </a>
                     ))}
               </div>
            </div>
         </div>
      </div>
   );
}
